import { QueryKey } from '../../constants/index';

/**
 * Every access mutation invalidates all of these.
 *
 * The candidate list belongs here too: granting access flips `hasAccess` on that person, so an
 * Invite modal reopened straight after a share would otherwise still offer them.
 */
export const DATA_ROOM_ACCESS_INVALIDATION_KEYS: QueryKey[] = [
  QueryKey.DATA_ROOM_ACCESS,
  QueryKey.DATA_ROOM_SHARE_CANDIDATES,
];
